import React from 'react';

export default function AjaxSpinner({type, is_loading=false})
{
    if(is_loading === false) return <></>
    return (
        <div className={is_loading === true ? 'loader loader--visible' : 'loader'}></div>
    );
};